
import Shop from './shop/ShopPage';

function Home() {
  
  return (<div><Shop/></div>);
}

export default Home;
